
import React, { Fragment } from 'react'

const Terms = (props) => {

    return (
        <Fragment>
            <div style={{ fontFamily: 'Open Sans, sans-serif', display: 'flex', height: '100%', flexDirection: 'column', padding: '10px 10px' }}>
                <div style={{ textAlign: 'center', display: 'flex', width: '100%', justifyContent: 'center', paddingTop: '20px', paddingBottom: '20px' }} ><img src={'https://memberships.tanglewoodresort.club/images/logo.png'} alt="Tanglewood Resort" /></div>

                <div style={{ position: 'relative', flex: '1 1 auto', overFlowY: 'auto', wordWrap: 'break-word' }} id="container" >

                    <p><strong>CHARGING DETAILS</strong></p>


                    <p>Membership Dues are to be paid in advance at the beginning of each month, and monthly charges are paid within 10 days of the end of each month. Members agree to pay in full the balance due on their account each month.An 18% service charge will be automatically included for any food or beverage item served unless specifically noted otherwise. (For instance, if a charge is incurred on a club member’s account, an 18% service charge will be added unless specified otherwise). Charges may be automatically paid with credit card on file with Tanglewood Resort and/or through ACH, which is preferred payment method.</p>

                   
                    <p id="rental"><strong>MEMBERSHIP RATES</strong></p>

                    <p>

                        Membership rates exclude taxes. Membership continues month to month until cancelled by the Member or Tanglewood Resort with ninety (90) days notice, at the then current membership rates. Rates are subject to change upon ninety (90) days notice to the Member. During March-August, must pay first month and last two months up front, for new membership applications.</p>

                    <p id="golfingWaiver">*Limits apply and Rules are subject to change. Golf is anytime course is open for play, but subject to Restrictions and Limits including scheduled tournaments and events, weather issues, maintenance needs, and limits due to high demand with respect to other golfers.</p>




                </div>
            </div>
        </Fragment >




    )
}


export default Terms